import type { HorasObra, NominaSemanal, Subcontrato } from '@adelante/shared';

/**
 * M.O. por obra acumulada sobre un conjunto de semanas (las de un mes).
 * Misma fórmula que calcularManoObra: nómina directa de la semana prorrateada
 * por las horas de cada obra + subcontratos de la obra. No filtra por venta
 * (el análisis mensual trabaja sobre todas las obras).
 */
export function moPorObraSemanas(
  semanaIds: number[],
  nominaArr: NominaSemanal[],
  horasArr: HorasObra[],
  subcArr: Subcontrato[],
): Map<string, number> {
  const out = new Map<string, number>();
  const sumar = (obra: string, monto: number) => out.set(obra, (out.get(obra) ?? 0) + monto);

  for (const sem of semanaIds) {
    const nomina = nominaArr.find((n) => Number(n.semana_operativa_id) === sem);
    const horas = horasArr.filter((h) => Number(h.semana_operativa_id) === sem);
    const horasTotal = horas.reduce((a, h) => a + Number(h.horas), 0);
    const montoNomina = nomina ? Number(nomina.monto_nomina_directa) : 0;
    if (horasTotal > 0 && montoNomina > 0) {
      for (const h of horas) sumar(h.obra_codigo, (Number(h.horas) / horasTotal) * montoNomina);
    }
    for (const s of subcArr) {
      if (Number(s.semana_operativa_id) === sem) sumar(s.obra_codigo, Number(s.monto));
    }
  }
  return out;
}
